import sharedRoutes from './shared-routes'
import userRoutes from './user-routes'
import agentRoutes from './agent-routes'
import supervisorRoutes from './supervisor-routes'
import leadSupervisorRoutes from './lead-supervisor-routes'
import managerRoutes from './manager-routes'
import adminRoutes from './admin-routes'
import DSMRoutes from './dsm-routes'
import SOMRoutes from './som-routes'
import collectionRoutes from './collection-routes'

const allRoutes = []

export default allRoutes.concat(
  sharedRoutes,
  adminRoutes,
  userRoutes,
  agentRoutes,
  supervisorRoutes,
  leadSupervisorRoutes,
  DSMRoutes,
  SOMRoutes,
  collectionRoutes,
  managerRoutes
)
